import { fetchApi } from '@/config/axiosSetting';
import { SignatureQueryParamsType } from '@/modules/adjusterReportModules/types/signatureQueryParams.type';

export const postPropertyCulpritSignatureQueryFunction = (
  params: Omit<SignatureQueryParamsType, 'damagedId'>,
): Promise<{}> => {
  return fetchApi({
    method: 'post',
    url: `/property/reports/${params.id}/accident_users/culprit/images/signature/`,
    data: params.data,
  });
};
